'use client';

const installSteps = [
  {
    number: '01',
    title: 'Strategy Call',
    description: 'We map your coaching process and philosophy. We understand how you work, what your clients need, and where the admin bottlenecks are.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
  },
  {
    number: '02',
    title: 'AI Customisation',
    description: 'We train the assistants on your tone, systems, and coaching philosophy. Every output reflects how you coach — not a generic template.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    number: '03',
    title: 'Go Live',
    description: 'Your AI Assistants run weekly inside your business. Onboarding, programming, and check-ins — handled. You coach. The system runs.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
];

export default function FoundingBatchSection() {
  return (
    <section
      id="installation"
      className="py-24 md:py-32 px-5 md:px-8 bg-surface"
    >
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="badge badge-coral mb-4">Installation Process</span>
          <h2 className="display-md text-foreground mb-5">
            Installed For You
            <br />
            <span className="gradient-text">in 3 Steps.</span>
          </h2>
          <p className="text-lg text-muted max-w-xl mx-auto">
            No technical skills required. We handle the full setup — you just approve and go live.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-14">
          {installSteps?.map((step, index) => (
            <div key={index} className="relative bg-white rounded-3xl p-8 border border-black/[0.07] hover:border-primary/30 transition-all duration-300 hover:shadow-lg">
              {/* Step number badge */}
              <div className="absolute -top-4 left-8">
                <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center text-white font-bold text-lg shadow-lg">
                  {step?.number}
                </div>
              </div>

              {/* Icon */}
              <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center text-primary mb-5 mt-5">
                {step?.icon}
              </div>

              <h3 className="text-xl font-bold text-foreground mb-3">{step?.title}</h3>
              <p className="text-muted leading-relaxed text-sm">{step?.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="text-center">
          <div className="inline-flex items-center gap-2 bg-primary/[0.06] border border-primary/15 rounded-full px-5 py-2.5">
            <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-bold text-primary">No technical skills required.</span>
          </div>
        </div>
      </div>
    </section>
  );
}